import { cn } from '@/lib/utils';

interface SaplingLogoProps {
  className?: string;
  showText?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const sizes = {
  sm: { icon: 24, height: 24, fontSize: 16 },
  md: { icon: 32, height: 32, fontSize: 20 },
  lg: { icon: 40, height: 40, fontSize: 24 },
};

export function SaplingLogo({
  className,
  showText = true,
  size = 'md',
}: SaplingLogoProps) {
  const { icon, height, fontSize } = sizes[size];
  const width = showText ? icon * 5 : icon;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${width} ${height}`}
      className={cn('flex-shrink-0', className)}
      style={{ width: 'auto', height }}
    >
      <defs>
        <linearGradient id="saplingLogoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#22C55E" />
          <stop offset="100%" stopColor="#16A34A" />
        </linearGradient>
      </defs>

      {/* Icon */}
      <rect
        x="0"
        y="0"
        width={icon}
        height={icon}
        rx={icon * 0.1875}
        fill="url(#saplingLogoGrad)"
      />
      <g transform={`scale(${icon / 32})`}>
        <path
          d="M16 6C11.58 6 8 9.58 8 14s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm-.8 14.35c-3.16-.39-5.6-3.08-5.6-6.35 0-.5.06-.97.17-1.43L13 14v.8c0 .88.72 1.6 1.6 1.6v1.95zm5.52-2.04c-.21-.65-.8-1.11-1.52-1.11h-.8v-2.4c0-.44-.36-.8-.8-.8h-4v-1.6h1.6c.44 0 .8-.36.8-.8v-1.6h1.6c.88 0 1.6-.72 1.6-1.6v-.33c2.35.95 4 3.25 4 5.93 0 1.66-.64 3.18-1.68 4.31z"
          fill="white"
        />
      </g>

      {/* Text */}
      {showText && (
        <text
          x={icon * 1.375}
          y={height * 0.7}
          fontFamily="'Plus Jakarta Sans', system-ui, sans-serif"
          fontSize={fontSize}
          fontWeight="700"
          className="fill-foreground"
        >
          Sapling
        </text>
      )}
    </svg>
  );
}
